
import { FIREARM_POOL_METADATA } from './firearm-pool.metadata';
import { FirearmPoolBase } from './firearm-pool.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface FirearmPool extends FirearmPoolBase {
}

export interface FirearmPoolTransient { }

export class FirearmPool extends CrudEntity<FirearmPool, number, FirearmPoolTransient> implements FirearmPoolTransient {
  constructor(source?: Partial<FirearmPool>, options?: CrudEntityConstructionOptions<FirearmPool, number, FirearmPoolTransient>) {
    super(FIREARM_POOL_METADATA, source, options);
  }
  
  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }
  
  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }
}





